import { ZsdFormIOComponent } from './zsdformio.component';
import { FormioModule, FormioAppConfig } from 'angular-formio';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppConfig } from '../formio-config';

@NgModule({
    imports: [
        CommonModule,
        FormioModule,
            ],
    declarations: [ZsdFormIOComponent],
    exports: [ZsdFormIOComponent],
    providers: [{provide: FormioAppConfig, useValue: AppConfig}],
})
export class ZsdFormIOModule { }
